import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./appRoutes";
const TutorRoot = (props) => {
  return (
    <Router basename={process.env.REACT_APP_APP_ENV}>
      <AppRoutes />
    </Router>
  );
};

export default TutorRoot;
